export default __webpack_public_path__ + "static/media/no-homework.d3e6c928.png";